// Per-module field lists shown in the Display Role field-visibility modal.
// module_id keys match TILE_REGISTRY ids.
// Add a new module here whenever you're ready to support Display-role field
// masking for it — until then, selecting Display for a module not listed
// here just shows "no fields configured yet" in the modal.

export const FIELD_REGISTRY = {
  SALES_INQUIRY: [
    { field_id: "enquiry_id", label: "Enquiry ID" },
    { field_id: "enquiry_type", label: "Enquiry Type" },
    { field_id: "sales_org", label: "Sales Org" },
    { field_id: "customer_segment", label: "Customer Segment" },
    { field_id: "distribution_channel", label: "Distribution Channel" },
    { field_id: "customer", label: "Customer" },
    { field_id: "submitted_by", label: "Submitted By" },
    { field_id: "created_by", label: "Created By" },
    { field_id: "created_date", label: "Created Date" },
    { field_id: "project", label: "Project" },
    { field_id: "enquiry_status", label: "Enquiry Status" },
    { field_id: "approved_by", label: "Approved By" },

    // Product Line Items is a table, not a single value — each column is
    // its own maskable field, grouped together in the UI under
    // "Product Line Items".
    { field_id: "item_no", label: "Item", group: "Product Line Items" },
    { field_id: "product_code", label: "Product Code", group: "Product Line Items" },
    { field_id: "fast_entry", label: "Fast Entry", group: "Product Line Items" },
    { field_id: "item_description", label: "Description", group: "Product Line Items" },
    { field_id: "uom", label: "UOM", group: "Product Line Items" },
    { field_id: "qty", label: "Qty", group: "Product Line Items" },
    { field_id: "range", label: "Range", group: "Product Line Items" },
    { field_id: "currency", label: "Currency", group: "Product Line Items" },
    { field_id: "unit_price", label: "Unit Price", group: "Product Line Items" },
    { field_id: "total_price", label: "Total Price", group: "Product Line Items" },
    { field_id: "req_date", label: "Req. Date", group: "Product Line Items" }
  ],

  SALES_QUOTATION: [
    { field_id: "rfq_id", label: "RFQ ID" },
    { field_id: "sales_org", label: "Sales Organization" },
    { field_id: "customer_segment", label: "Customer Segment" },
    { field_id: "distribution_channel", label: "Distribution Channel" },
    { field_id: "created_by", label: "Created By" },
    { field_id: "created_date", label: "Created Date" },
    { field_id: "approved_by", label: "Approved By" },
    { field_id: "approved_date", label: "Approved Date" },
    { field_id: "markup_percent", label: "Markup (%)" },
    { field_id: "customer_inspection", label: "Customer Inspection" },
    { field_id: "validity", label: "Validity" },
    { field_id: "customer", label: "Customer" },
    { field_id: "enquiry_id", label: "Enquiry ID" },
    { field_id: "quotation_rev_no", label: "Quotation Rev No." },
    { field_id: "customer_country", label: "Customer Country" },
    { field_id: "payment_terms", label: "Payment Terms" },
    { field_id: "order_value", label: "Order Value" },
    { field_id: "rfq_status", label: "Status" },

    // Product Line Items — one entry per column in the quotation's item table.
    { field_id: "item_no", label: "Item", group: "Product Line Items" },
    { field_id: "product_code", label: "Product Code", group: "Product Line Items" },
    { field_id: "fast_entry", label: "Fast Entry", group: "Product Line Items" },
    { field_id: "item_description", label: "Description", group: "Product Line Items" },
    { field_id: "hsn_code", label: "HSN Code", group: "Product Line Items" },
    { field_id: "uom", label: "UOM", group: "Product Line Items" },
    { field_id: "qty", label: "Qty", group: "Product Line Items" },
    { field_id: "tol_range", label: "Tol. Range", group: "Product Line Items" },
    { field_id: "currency", label: "Currency", group: "Product Line Items" },
    { field_id: "unit_price", label: "Unit Price", group: "Product Line Items" },
    { field_id: "total_price", label: "Total Price", group: "Product Line Items" },
    { field_id: "discount_percent", label: "Disc (%)", group: "Product Line Items" },
    { field_id: "line_markup_percent", label: "Markup (%)", group: "Product Line Items" },
    { field_id: "discounted_price", label: "Discounted Price", group: "Product Line Items" },
    { field_id: "net_price", label: "Net Price", group: "Product Line Items" },
    { field_id: "cgst", label: "CGST", group: "Product Line Items" },
    { field_id: "sgst", label: "SGST", group: "Product Line Items" },
    { field_id: "igst", label: "IGST", group: "Product Line Items" },
    { field_id: "total_gst", label: "Total GST", group: "Product Line Items" },
    { field_id: "grand_total", label: "Grand Total", group: "Product Line Items" },
    { field_id: "req_date", label: "Req. Date", group: "Product Line Items" },
    { field_id: "min_order_qty", label: "Min. Order Qty", group: "Product Line Items" },

    // Docs tab — each doc type toggled independently, not a single field.
    { field_id: "quotation_pdf", label: "Quotation PDF", group: "Docs" },
    { field_id: "gtp_datasheet", label: "GTP Datasheet", group: "Docs" },
    { field_id: "uploaded_files", label: "Uploaded Files", group: "Docs" }
  ],

  SALES_ORDER: [
    { field_id: "so_id", label: "SO ID" },
    { field_id: "order_type", label: "Order Type" },
    { field_id: "rfq_id", label: "RFQ ID" },
    { field_id: "customer", label: "Customer" },
    { field_id: "sales_organization", label: "Sales Organization" },
    { field_id: "customer_segment", label: "Customer Segment" },
    { field_id: "distribution_channel", label: "Distribution Channel" },
    { field_id: "purchase_order", label: "Purchase Order" },
    { field_id: "advance_payment", label: "Advance Payment" },
    { field_id: "so_status", label: "Status" },
    { field_id: "header_markup", label: "Markup (%)" },
    { field_id: "header_req_date", label: "Req. Date (All Products)" },
    { field_id: "planning_block", label: "Planning Block" },
    { field_id: "sales_block", label: "Sales Block" },
    { field_id: "quotation_type", label: "Quotation Type" },
    { field_id: "rc_number", label: "RC Number" },
    { field_id: "type_of_packing", label: "Type of Packing" },
    { field_id: "payment_terms", label: "Payment Terms" },
    { field_id: "validity_terms", label: "Validity Terms" },
    { field_id: "validity_date", label: "Validity Date" },
    { field_id: "currency", label: "Currency" },
    { field_id: "customer_inspection", label: "Customer Inspection" },
    { field_id: "customer_inspection_proposed_date", label: "Inspection Proposed Date" },
    { field_id: "customer_inspection_proposed_time", label: "Inspection Proposed Time" },
    { field_id: "customer_inspection_proposed_source", label: "Inspection Proposed Source" },
    { field_id: "customer_inspection_assigned_to", label: "Inspection Assigned To" },
    { field_id: "customer_inspection_confirmed_date", label: "Inspection Confirmed Date" },
    { field_id: "customer_inspection_confirmed_time", label: "Inspection Confirmed Time" },
    { field_id: "created_by", label: "Created By" },
    { field_id: "creation_date", label: "Created Date" },
    { field_id: "approved_by", label: "Approved By" },
    { field_id: "approved_at", label: "Approved Date" },

    // Product Line Items — one entry per column in the sales order's item table.
    { field_id: "item_no", label: "Item", group: "Product Line Items" },
    { field_id: "product_code", label: "Product Code", group: "Product Line Items" },
    { field_id: "product_class", label: "Product Class", group: "Product Line Items" },
    { field_id: "item_description", label: "Description", group: "Product Line Items" },
    { field_id: "uom", label: "UOM", group: "Product Line Items" },
    { field_id: "quantity", label: "Qty", group: "Product Line Items" },
    { field_id: "requirement_date", label: "Req. Date", group: "Product Line Items" },
    { field_id: "unit_price", label: "Unit Price", group: "Product Line Items" },
    { field_id: "unit_cost", label: "Unit Cost", group: "Product Line Items" },
    { field_id: "discount", label: "Disc (%)", group: "Product Line Items" },
    { field_id: "line_markup", label: "Markup (%)", group: "Product Line Items" },
    { field_id: "total_price", label: "Total Price", group: "Product Line Items" },
    { field_id: "discounted_price", label: "Discounted Price", group: "Product Line Items" },
    { field_id: "net_price_after_discount", label: "Net Price", group: "Product Line Items" },
    { field_id: "hsn_code", label: "HSN Code", group: "Product Line Items" },
    { field_id: "cgst", label: "CGST", group: "Product Line Items" },
    { field_id: "sgst", label: "SGST", group: "Product Line Items" },
    { field_id: "igst", label: "IGST", group: "Product Line Items" },
    { field_id: "total_gst", label: "Total GST", group: "Product Line Items" },
    { field_id: "final_price_after_gst", label: "Grand Total", group: "Product Line Items" },
    { field_id: "tentative_conf_qty", label: "Tentative Conf. Qty", group: "Product Line Items" },
    { field_id: "tentative_conf_date", label: "Tentative Conf. Date", group: "Product Line Items" },
    { field_id: "confirmation_qty", label: "Confirmation Qty", group: "Product Line Items" },
    { field_id: "confirmation_date", label: "Confirmation Date", group: "Product Line Items" },
    { field_id: "delivery_date", label: "Delivery Date", group: "Product Line Items" },
    { field_id: "receiving_date", label: "Receiving Date", group: "Product Line Items" },
    { field_id: "transportation_date", label: "Transportation Date", group: "Product Line Items" },
    { field_id: "packing_date", label: "Packing Date", group: "Product Line Items" },
    { field_id: "picking_date", label: "Picking Date", group: "Product Line Items" },
    { field_id: "mad", label: "MAD", group: "Product Line Items" },

    // Docs tab — each doc type toggled independently, not a single field.
    { field_id: "uploaded_files", label: "Uploaded Files", group: "Docs" }
  ],
  PURCHASE_REQ: [
    { field_id: "product_type", label: "Product Type" },
    { field_id: "purchase_organization", label: "Purchase Organization" },
    { field_id: "purchase_planner", label: "Purchase Planner" },
    { field_id: "location", label: "Location" },
    { field_id: "created_by", label: "Created By" },
    { field_id: "created_date", label: "Created Date" },
    { field_id: "approved_by", label: "Approved By" },
    { field_id: "approved_date", label: "Approved Date" },

    // Product line item fields — row 0, "+ Add Product" rows, and the
    // Review tab's summary table all share these same field_ids.
    { field_id: "product_code", label: "Product Code", group: "Product Line Items" },
    { field_id: "item_description", label: "Description", group: "Product Line Items" },
    { field_id: "uom", label: "UOM", group: "Product Line Items" },
    { field_id: "requirement_qty", label: "Qty", group: "Product Line Items" },
    { field_id: "requirement_date", label: "Requirement Date", group: "Product Line Items" },
    { field_id: "hsn_code", label: "HSN Code", group: "Product Line Items" }
  ],
  PURCHASE_ORDER: [
    { field_id: "purchase_order_id", label: "PO No" },
    { field_id: "product_type", label: "Product Type" },
    { field_id: "purchase_organization", label: "Purchase Organization" },
    { field_id: "purchase_planner", label: "Purchase Planner" },
    { field_id: "location", label: "Location" },
    { field_id: "vendor", label: "Supplier" },
    { field_id: "quote_no", label: "Quote No" },
    { field_id: "quote_date", label: "Quote Date" },
    { field_id: "payment_terms", label: "Payment Terms" },
    { field_id: "terms_and_conditions", label: "Terms & Conditions" },
    { field_id: "mode_of_transport", label: "Mode Of Transport" },
    { field_id: "delivery_type", label: "Delivery Type" },
    { field_id: "freight_terms", label: "Freight Terms" },
    { field_id: "insurance_terms", label: "Insurance Terms" },
    { field_id: "transporter", label: "Transporter" },
    { field_id: "po_header_lot_type", label: "PO Header Lot Type" },
    { field_id: "created_by", label: "Created By" },
    { field_id: "created_date", label: "Created Date" },
    { field_id: "approved_by", label: "Approved By" },
    { field_id: "approved_date", label: "Approved Date" },
    { field_id: "po_status", label: "Status" },
    { field_id: "order_type", label: "Order Type" },
    { field_id: "po_revision_no", label: "PO Revision No." },

    // Contact Details (Name / Email Id / Contact No.)
    { field_id: "contact_name", label: "Contact Name" },
    { field_id: "contact_email", label: "Contact Email Id" },
    { field_id: "contact_phone", label: "Contact No." },

    // Product Line Items — one entry per column in the PO's item table.
    { field_id: "item_no", label: "Item", group: "Product Line Items" },
    { field_id: "product_code", label: "Product Code", group: "Product Line Items" },
    { field_id: "product_class", label: "Product Class", group: "Product Line Items" },
    { field_id: "description", label: "Description", group: "Product Line Items" },
    { field_id: "requirement_qty", label: "Qty", group: "Product Line Items" },
    { field_id: "purchase_class", label: "Purchase Class", group: "Product Line Items" },
    { field_id: "range", label: "Range", group: "Product Line Items" },
    { field_id: "uom", label: "UOM", group: "Product Line Items" },
    { field_id: "currency", label: "Currency", group: "Product Line Items" },
    { field_id: "hsn_code", label: "HSN Code", group: "Product Line Items" },
    { field_id: "product_cost", label: "Unit Cost", group: "Product Line Items" },
    { field_id: "discount", label: "Disc (%)", group: "Product Line Items" },
    { field_id: "total_cost", label: "Total Cost", group: "Product Line Items" },
    { field_id: "net_price", label: "Net Price", group: "Product Line Items" },
    { field_id: "cgst_percent", label: "CGST", group: "Product Line Items" },
    { field_id: "sgst_percent", label: "SGST", group: "Product Line Items" },
    { field_id: "igst_percent", label: "IGST", group: "Product Line Items" },
    { field_id: "grand_total", label: "Grand Total", group: "Product Line Items" },
    { field_id: "delivery_date", label: "Delivery Date", group: "Product Line Items" },
    { field_id: "over_tolerance", label: "Over Tolerance (%)", group: "Product Line Items" },
    { field_id: "country_of_origin", label: "Country Of Origin", group: "Product Line Items" },

    // Customs tab (Import POs only).
    { field_id: "supplier_country", label: "Supplier Country", group: "Customs" },
    { field_id: "import_currency", label: "Currency", group: "Customs" },
    { field_id: "exchange_rate", label: "Exchange Rate", group: "Customs" },
    { field_id: "incoterm", label: "Incoterm", group: "Customs" },
    { field_id: "port_of_loading", label: "Port Of Loading", group: "Customs" },
    { field_id: "port_of_discharge", label: "Port Of Discharge", group: "Customs" },
    { field_id: "final_destination", label: "Final Destination", group: "Customs" },
    { field_id: "expected_shipment_date", label: "Expected Shipment Date", group: "Customs" },
    { field_id: "expected_arrival_date", label: "Expected Arrival Date", group: "Customs" },
    { field_id: "lc_required", label: "LC Required", group: "Customs" },
    { field_id: "insurance_required", label: "Insurance Required", group: "Customs" },

    // Port/Clearing and Bank landed-cost tabs (Import POs only).
    { field_id: "cha_cf_charges", label: "CHA/C&F Charges", group: "Port/Clearing" },
    { field_id: "port_charges", label: "Port Charges", group: "Port/Clearing" },
    { field_id: "documentation_charges", label: "Documentation Charges", group: "Port/Clearing" },
    { field_id: "demurrage", label: "Demurrage", group: "Port/Clearing" },
    { field_id: "detention", label: "Detention", group: "Port/Clearing" },
    { field_id: "lc_charges", label: "LC Charges", group: "Bank" },
    { field_id: "bank_charges", label: "Bank Charges", group: "Bank" },
    { field_id: "forex_charges", label: "Forex Charges", group: "Bank" },

    // Review tab.
    { field_id: "review_comment", label: "Comment / Remarks", group: "Review" },

    // Confirmation tab.
    { field_id: "schedule_line", label: "Schedule Line", group: "Confirmation" },
    { field_id: "confirm_qty", label: "Confirm Qty", group: "Confirmation" },
    { field_id: "confirm_date", label: "Confirm Date", group: "Confirmation" },
    { field_id: "deliver_qty", label: "Deliver Qty", group: "Confirmation" },
    { field_id: "deliver_date", label: "Deliver Date", group: "Confirmation" },

    // Payment History tab.
    { field_id: "payment_type", label: "Payment Type", group: "Payment History" },
    { field_id: "payment_date", label: "Date", group: "Payment History" },
    { field_id: "payment_amount", label: "Amount", group: "Payment History" },
    { field_id: "payment_description", label: "Payment Description", group: "Payment History" },
    { field_id: "payment_reference_no", label: "Reference Number", group: "Payment History" },
    { field_id: "balance_remaining", label: "Balance Remaining", group: "Payment History" },

    // Acknowledgement tab.
    { field_id: "acknowledgement_no", label: "Acknowledgement No", group: "Acknowledgement" },
    { field_id: "acknowledgement_date", label: "Date", group: "Acknowledgement" },

    // Docs tab.
    { field_id: "purchase_order_pdf", label: "Purchase Order PDF", group: "Docs" },
    { field_id: "uploaded_files", label: "Uploaded Files", group: "Docs" }
  ],

  SFC_PLANNED_ORDER: [
    { field_id: "planned_order_no", label: "Planned Order No" },
    { field_id: "product_code", label: "Product Code" },
    { field_id: "description", label: "Description" },
    { field_id: "uom", label: "UOM" },
    { field_id: "qty", label: "Order Qty" },
    { field_id: "alt_bom", label: "Alt. BOM" },
    { field_id: "base_unit", label: "Base Unit" },
    { field_id: "workcenter", label: "Workcenter" },
    { field_id: "start_date", label: "Prod. Start Date" },
    { field_id: "end_date", label: "Prod. End Date" },
    { field_id: "requirement_date", label: "Requirement Date" },
    { field_id: "created_by", label: "Created By" },
    { field_id: "sales_order", label: "Sales Order" },
    { field_id: "so_item", label: "SO Item" },
    { field_id: "customer", label: "Customer" },
    { field_id: "purchase_order", label: "Purchase Order" },
    { field_id: "so_qty", label: "SO Qty" },
    { field_id: "converted_production_no", label: "Converted Production Order" },

    // Product spec strip — auto-filled from Product Master, shown as its
    // own labeled subsection in the field-visibility picker.
    { field_id: "construction", label: "Construction", group: "Product Spec" },
    { field_id: "code", label: "Code", group: "Product Spec" },
    { field_id: "cable_type", label: "Cable Type", group: "Product Spec" },
    { field_id: "product_category", label: "Category", group: "Product Spec" },
    { field_id: "no_of_cores", label: "Cores", group: "Product Spec" },
    { field_id: "color", label: "Color", group: "Product Spec" },
    { field_id: "nominal_cross_section", label: "Cross Section", group: "Product Spec" },
    { field_id: "reference_of_standard", label: "Std. Ref", group: "Product Spec" },
    { field_id: "voltage", label: "Voltage", group: "Product Spec" },

    // Material Details tab — BOM-exploded component table, one entry per column.
    { field_id: "component_product_code", label: "Product Code", group: "Material Details" },
    { field_id: "component_description", label: "Description", group: "Material Details" },
    { field_id: "component_quantity", label: "Quantity", group: "Material Details" },
    { field_id: "component_total_qty", label: "Total Qty", group: "Material Details" },
    { field_id: "component_uom", label: "UOM", group: "Material Details" },

    // Machine Time tab — routing/schedule table.
    { field_id: "operation_workcenter", label: "Workcenter", group: "Machine Time" },
    { field_id: "operation_start", label: "Start", group: "Machine Time" },
    { field_id: "operation_end", label: "End", group: "Machine Time" }
  ],

  SFC_PRODUCTION_ORDER: [
    { field_id: "production_order_number", label: "Production Order No" },
    { field_id: "product_type", label: "Product Type" },
    { field_id: "product_code", label: "Product Code" },
    { field_id: "description", label: "Description" },
    { field_id: "uom", label: "UOM" },
    { field_id: "order_qty", label: "Order Qty" },
    { field_id: "range", label: "Range" },
    { field_id: "alt_bom", label: "Alt. BOM" },
    { field_id: "base_unit", label: "Base Unit" },
    { field_id: "prod_start_date", label: "Prod. Start Date" },
    { field_id: "prod_start_time", label: "Prod. Start Time" },
    { field_id: "prod_end_date", label: "Prod. End Date" },
    { field_id: "prod_end_time", label: "Prod. End Time" },
    { field_id: "created_by", label: "Created By" },
    { field_id: "released_by", label: "Released By" },
    { field_id: "release_status", label: "Release Status" },
    { field_id: "workcenter", label: "Workcenter" },

    // Sales Order reference strip shown against the production order.
    { field_id: "sales_order", label: "Sales Order", group: "Sales Order Reference" },
    { field_id: "so_item", label: "Item", group: "Sales Order Reference" },
    { field_id: "so_customer", label: "Customer", group: "Sales Order Reference" },
    { field_id: "so_purchase_order", label: "Purchase Order", group: "Sales Order Reference" },
    { field_id: "so_req_date", label: "Req. Date", group: "Sales Order Reference" },
    { field_id: "so_qty", label: "Qty", group: "Sales Order Reference" },

    // Material Details tab — BOM-exploded component table, one entry per column.
    { field_id: "component_item", label: "Item", group: "Material Details" },
    { field_id: "component_product_type", label: "Product Type", group: "Material Details" },
    { field_id: "component_product_code", label: "Product Code", group: "Material Details" },
    { field_id: "component_description", label: "Description", group: "Material Details" },
    { field_id: "component_total_qty", label: "Total Qty", group: "Material Details" },
    { field_id: "component_uom", label: "UOM", group: "Material Details" },

    // Machine Time tab — routing/schedule table.
    { field_id: "operation_process", label: "Process", group: "Machine Time" },
    { field_id: "operation_workcenter", label: "Workcenter", group: "Machine Time" },
    { field_id: "operation_machine", label: "Machine", group: "Machine Time" },
    { field_id: "operation_setup", label: "Setup", group: "Machine Time" },
    { field_id: "operation_run_time", label: "Run Time", group: "Machine Time" },
    { field_id: "operation_labour", label: "Labour", group: "Machine Time" },
    { field_id: "operation_overhead", label: "Overhead", group: "Machine Time" },
    { field_id: "operation_start", label: "Start Date/Time", group: "Machine Time" },
    { field_id: "operation_end", label: "End Date/Time", group: "Machine Time" },

    // Process / Machine / Inspection Parameter accordions.
    { field_id: "process_parameter", label: "Process Parameter", group: "Routing Parameters" },
    { field_id: "machine_parameter", label: "Machine Parameter", group: "Routing Parameters" },
    { field_id: "inspection_parameter", label: "Inspection Parameter", group: "Routing Parameters" },

    // Docs tab.
    { field_id: "job_order_doc", label: "Job Order", group: "Docs" },
    { field_id: "uploaded_files", label: "Uploaded Files", group: "Docs" }
  ],

  SFC_CONFIRMATION: [
    { field_id: "production_order_number", label: "Production Order" },
    { field_id: "confirmation_id", label: "Confirmation ID" },
    { field_id: "product_code", label: "Product Code" },
    { field_id: "description", label: "Description" },
    { field_id: "uom", label: "UOM" },
    { field_id: "order_qty", label: "Order Qty" },
    { field_id: "range", label: "Range" },
    { field_id: "produced", label: "Produced" },
    { field_id: "pending", label: "Pending" },
    { field_id: "workcenter", label: "Workcenter" },
    { field_id: "release_status", label: "Status" },

    // Planned section.
    { field_id: "prod_start_date", label: "Prod. Start Date", group: "Planned" },
    { field_id: "prod_start_time", label: "Prod. Start Time", group: "Planned" },
    { field_id: "prod_end_date", label: "Prod. End Date", group: "Planned" },
    { field_id: "prod_end_time", label: "Prod. End Time", group: "Planned" },
    { field_id: "created_by", label: "Created By", group: "Planned" },
    { field_id: "released_by", label: "Released By", group: "Planned" },

    // Actual section.
    { field_id: "actual_start_date", label: "Actual Start Date", group: "Actual" },
    { field_id: "actual_start_time", label: "Actual Start Time", group: "Actual" },
    { field_id: "actual_end_date", label: "Actual End Date", group: "Actual" },
    { field_id: "actual_end_time", label: "Actual End Time", group: "Actual" },
    { field_id: "operator_name", label: "Operator Name", group: "Actual" },
    { field_id: "qc_checked_by", label: "QC Checked By", group: "Actual" },

    // Material Details tab — BOM-exploded component table, one entry per column.
    { field_id: "component_item", label: "Item", group: "Material Details" },
    { field_id: "component_product_code", label: "Product Code", group: "Material Details" },
    { field_id: "component_description", label: "Description", group: "Material Details" },
    { field_id: "component_total_qty", label: "Total Qty", group: "Material Details" },
    { field_id: "component_uom", label: "UOM", group: "Material Details" },

    // Machine Time tab — routing/schedule table.
    { field_id: "operation_workcenter", label: "Workcenter", group: "Machine Time" },
    { field_id: "operation_start", label: "Start", group: "Machine Time" },
    { field_id: "operation_end", label: "End", group: "Machine Time" },

    // Docs tab.
    { field_id: "uploaded_files", label: "Uploaded Files", group: "Docs" }
  ],

  SFC_GOODS_REQUEST: [
    // Active tab — open production-order lines not yet requested.
    { field_id: "production_order_number", label: "Production Order", group: "Active" },
    { field_id: "sales_order_numbers", label: "Sales Order", group: "Active" },
    { field_id: "workcenter_name", label: "Workcenter", group: "Active" },
    { field_id: "product_code", label: "Product Code", group: "Active" },
    { field_id: "description", label: "Description", group: "Active" },
    { field_id: "uom", label: "UOM", group: "Active" },
    { field_id: "qty", label: "Actual Qty", group: "Active" },

    // Requested tab — summary row per request_no (line detail lives in
    // the View modal's Product tab).
    { field_id: "request_no", label: "Request No", group: "Requested" },

    // Confirmed tab — issued/confirmed request lines.
    { field_id: "issue_no", label: "Issue No", group: "Confirmed" },
    { field_id: "request_qty", label: "Requested Qty", group: "Confirmed" },
    { field_id: "request_date", label: "Requested Date", group: "Confirmed" },
    { field_id: "available_stock", label: "Available Stock", group: "Confirmed" },
    { field_id: "to_storage_location", label: "To Storage Location", group: "Confirmed" },
    { field_id: "issued_qty", label: "Issued Qty", group: "Confirmed" },
    { field_id: "issued_date", label: "Issued Date", group: "Confirmed" },
    { field_id: "from_storage_location", label: "From Storage Location", group: "Confirmed" },
    { field_id: "confirm_status", label: "Status", group: "Confirmed" },

    // View/Docs modal — product line detail + printable form.
    { field_id: "storage_code", label: "Storage Location", group: "View / Docs" },
    { field_id: "goods_request_pdf", label: "Goods Request PDF", group: "View / Docs" }
  ],

  SFC_REWORK_ORDER: [
    // Active tab — rejected batches not yet converted.
    { field_id: "productionOrder", label: "Production Order", group: "Active" },
    { field_id: "batch", label: "Batch Number", group: "Active" },
    { field_id: "productCode", label: "Product Code", group: "Active" },
    { field_id: "description", label: "Description", group: "Active" },
    { field_id: "workcenter", label: "Workcenter", group: "Active" },
    { field_id: "orderQty", label: "Order Qty", group: "Active" },
    { field_id: "startDate", label: "Start Date", group: "Active" },
    { field_id: "endDate", label: "End Date", group: "Active" },

    // Posted tab — batches already converted into a Rework Order.
    { field_id: "reworkOrderNo", label: "Rework Order", group: "Posted" }
  ],

  QUALITY_INSPECTION: [
    { field_id: "format_number", label: "Format Number" },
    { field_id: "product_code", label: "Product Code" },
    { field_id: "product_description", label: "Description" },
    { field_id: "batch_number", label: "Batch Number" },
    { field_id: "test_type", label: "Test Type" },
    { field_id: "inspection_type", label: "Inspection Type" },
    { field_id: "status", label: "Status" },
    { field_id: "inspected_by", label: "Inspected By" },
    { field_id: "wi_no", label: "WI No" },
    { field_id: "ref_no", label: "Ref No" },
    { field_id: "inspect_qty", label: "Inspect Qty" },

    // Inspection list (table) columns.
    { field_id: "product_type", label: "Product Type", group: "List Columns" },
    { field_id: "doc_no", label: "Doc No", group: "List Columns" },
    { field_id: "sales_order", label: "Sales Order No", group: "List Columns" },
    { field_id: "supplier", label: "Supplier / Customer", group: "List Columns" },
    { field_id: "qty", label: "Qty", group: "List Columns" },
    { field_id: "uom", label: "UOM", group: "List Columns" },
    { field_id: "date_of_testing", label: "Date of Testing", group: "List Columns" },

    // Characteristics table — one entry per column in the sample grid.
    { field_id: "characteristic", label: "Characteristic", group: "Characteristics" },
    { field_id: "standard_value", label: "Standard Value", group: "Characteristics" },
    { field_id: "sample_values", label: "Sample Values", group: "Characteristics" },
    { field_id: "manual_result", label: "Manual Result", group: "Characteristics" },

    // Drum Assignment tab.
    { field_id: "drum_type", label: "Drum Type", group: "Drum Assignment" },
    { field_id: "drum_material", label: "Drum Material", group: "Drum Assignment" },
    { field_id: "drum_no", label: "Drum No", group: "Drum Assignment" },
    { field_id: "top_m", label: "Top (m)", group: "Drum Assignment" },
    { field_id: "bottom_m", label: "Bottom (m)", group: "Drum Assignment" },
    { field_id: "length_m", label: "Length (m)", group: "Drum Assignment" },
    { field_id: "temp", label: "Temp", group: "Drum Assignment" },
    { field_id: "assigned_date", label: "Assigned Date", group: "Drum Assignment" },
    { field_id: "assigned_by", label: "Assigned By", group: "Drum Assignment" }
  ],

  GATE_PASS: [
    { field_id: "gate_pass_no", label: "Gate Pass No" },
    { field_id: "gate_pass_type", label: "Gate Pass Type" },
    { field_id: "location", label: "Location" },
    { field_id: "department", label: "Department" },
    { field_id: "requestor_name", label: "Requestor Name" },
    { field_id: "request_datetime", label: "Request Date/Time" },
    { field_id: "reference_doc_type", label: "Reference Doc Type" },
    { field_id: "reference_doc_no", label: "Reference Doc No" },
    { field_id: "delivery_note_no", label: "Delivery Note No" },
    { field_id: "vendor_name_address", label: "Vendor Name & Address" },
    { field_id: "in_time", label: "In Time" },
    { field_id: "security_name_in", label: "Security Name (In)" },
    { field_id: "out_time", label: "Out Time" },
    { field_id: "security_name_out", label: "Security Name (Out)" },
    { field_id: "security_comments", label: "Security Comments" },
    { field_id: "received_by", label: "Received By" },
    { field_id: "received_date", label: "Received Date" },
    { field_id: "vehicle_number", label: "Vehicle Number" },
    { field_id: "driver_name", label: "Driver Name" },
    { field_id: "status", label: "Status" },

    // Product line table — one entry per column in the gate pass's item grid.
    { field_id: "product_code", label: "Product Code", group: "Product Line Items" },
    { field_id: "product_description", label: "Description", group: "Product Line Items" },
    { field_id: "package_type", label: "Package Type", group: "Product Line Items" },
    { field_id: "number", label: "Number of Packages", group: "Product Line Items" },
    { field_id: "quantity", label: "Quantity", group: "Product Line Items" },
    { field_id: "received_quantity", label: "Received Quantity", group: "Product Line Items" },
    { field_id: "quantity_uom", label: "Qty UOM", group: "Product Line Items" },
    { field_id: "weight", label: "Weight", group: "Product Line Items" },
    { field_id: "weight_uom", label: "Weight UOM", group: "Product Line Items" },
    { field_id: "reason_for_movement", label: "Reason for Movement", group: "Product Line Items" },
    { field_id: "grn_number", label: "GRN Number", group: "Product Line Items" },
    { field_id: "batch_number", label: "Batch Number", group: "Product Line Items" },

    // Docs tab.
    { field_id: "attachments", label: "Attachments", group: "Docs" }
  ],

  GOODS_RECEIPT: [
    { field_id: "grn_number", label: "GRN Number" },
    { field_id: "format_no", label: "Format No" },
    { field_id: "purchase_order_id", label: "Purchase Order" },
    { field_id: "purchase_organization", label: "Purchase Organization" },
    { field_id: "vendor_name", label: "Vendor" },
    { field_id: "received_date", label: "Received Date" },
    { field_id: "status", label: "Status" },
    { field_id: "invoice_no", label: "Invoice No" },
    { field_id: "payment_terms", label: "Payment Terms" },
    { field_id: "mode_of_transport", label: "Mode of Transport" },
    { field_id: "delivery_type", label: "Delivery Type" },
    { field_id: "freight_terms", label: "Freight Terms" },
    { field_id: "insurance_terms", label: "Insurance Terms" },
    { field_id: "transporter", label: "Transporter" },
    { field_id: "purchase_type", label: "Purchase Type" },
    { field_id: "state_grouping", label: "State Grouping" },
    { field_id: "po_header_lot_type", label: "PO Header Lot Type" },
    { field_id: "storage_location", label: "Storage Location" },
    { field_id: "storage_code", label: "Storage Code" },
    { field_id: "gate_pass_no", label: "Gate Pass No" },
    { field_id: "final_price_after_gst", label: "Final Price (after GST)" },
    { field_id: "total_gst_amount", label: "Total GST Amount" },

    // Line item table — one entry per column in the GRN's item/batch grid.
    { field_id: "product_code", label: "Product Code", group: "Product Line Items" },
    { field_id: "product_type", label: "Product Type", group: "Product Line Items" },
    { field_id: "batch_number", label: "Batch Number", group: "Product Line Items" },
    { field_id: "received_qty", label: "Received Qty", group: "Product Line Items" },
    { field_id: "uom", label: "UOM", group: "Product Line Items" },
    { field_id: "range_min", label: "Range Min", group: "Product Line Items" },
    { field_id: "range_max", label: "Range Max", group: "Product Line Items" },

    // Docs tab.
    { field_id: "invoice_upload", label: "Invoice Upload", group: "Docs" }
  ],

  OUTBOUND_GOODS_ISSUE: [
    // Active tab — open requested lines not yet issued.
    { field_id: "production_order_number", label: "Production Order", group: "Active" },
    { field_id: "sales_order_numbers", label: "Sales Order", group: "Active" },
    { field_id: "workcenter_name", label: "Workcenter", group: "Active" },
    { field_id: "product_code", label: "Product Code", group: "Active" },
    { field_id: "description", label: "Description", group: "Active" },
    { field_id: "uom", label: "UOM", group: "Active" },
    { field_id: "qty", label: "Actual Qty", group: "Active" },
    { field_id: "request_qty", label: "Requested Qty", group: "Active" },
    { field_id: "open_qty", label: "Open Qty", group: "Active" },
    { field_id: "request_date", label: "Requested Date", group: "Active" },
    { field_id: "storage_location", label: "To/From Storage Location", group: "Active" },

    // Issued tab — lines already issued against a request.
    { field_id: "issue_no", label: "Issue No", group: "Issued" },
    { field_id: "to_storage_location", label: "To Storage Location", group: "Issued" },
    { field_id: "stock_qty", label: "Available Stock", group: "Issued" },
    { field_id: "batch_number", label: "Batch Number", group: "Issued" },
    { field_id: "issue_qty", label: "Issued Qty", group: "Issued" },
    { field_id: "issue_date", label: "Issued Date", group: "Issued" },
    { field_id: "status", label: "Status", group: "Issued" },

    // View/Docs modal — batch-level detail + printable Material Issue slip.
    { field_id: "goods_issue_pdf", label: "Goods Issue PDF", group: "View / Docs" }
  ],

  BUSINESS_PARTNER: [
  { field_id: "partner_code", label: "Partner Code" },
  { field_id: "partner_type", label: "Partner Type" },
  { field_id: "business_partner_name", label: "Business Partner Name" },
  { field_id: "legal_name", label: "Legal Name" },
  { field_id: "business_type", label: "Business Type" },
  { field_id: "category_master", label: "Category" },
  { field_id: "business_partner_group", label: "Group" },
  { field_id: "sales_person", label: "Sales Person" },
  { field_id: "business_partner_responsible", label: "Responsible Person" },
  { field_id: "partner_responsible_phone", label: "Responsible Phone" },
  { field_id: "partner_responsible_email", label: "Responsible Email" },
  { field_id: "terms_and_conditions", label: "Terms & Conditions" },

  { field_id: "pan", label: "PAN", group: "Tax & Compliance" },
  { field_id: "pan_status", label: "PAN Status", group: "Tax & Compliance" },
  { field_id: "date_of_corporation", label: "Date of Corporation", group: "Tax & Compliance" },
  { field_id: "pan_holder_category", label: "PAN Holder Category", group: "Tax & Compliance" },
  { field_id: "gstin", label: "GSTIN", group: "Tax & Compliance" },
  { field_id: "cin", label: "CIN", group: "Tax & Compliance" },
  { field_id: "udyam_registration", label: "Udyam / MSME", group: "Tax & Compliance" },
  { field_id: "shop_establishment_license", label: "Shop / Establishment License", group: "Tax & Compliance" },
  { field_id: "tds_tan", label: "TAN", group: "Tax & Compliance" },
  { field_id: "esi_pf", label: "ESI / PF No.", group: "Tax & Compliance" },
  { field_id: "professional_tax", label: "Professional Tax", group: "Tax & Compliance" },
  { field_id: "import_export_code", label: "IEC", group: "Tax & Compliance" },

  { field_id: "bank_name", label: "Bank Name", group: "Bank Details" },
  { field_id: "branch", label: "Branch", group: "Bank Details" },
  { field_id: "account_number", label: "Account Number", group: "Bank Details" },
  { field_id: "ifsc_code", label: "IFSC Code", group: "Bank Details" },

  { field_id: "shipping_address", label: "Shipping Address", group: "Addresses" },
  { field_id: "billing_address", label: "Billing Address", group: "Addresses" },
  { field_id: "address", label: "Address (Supplier)", group: "Addresses" }
],

 PROD_CODE: [
    // ---------- Classification ----------
    { field_id: "productGroup", label: "Product Group", group: "Classification" },
    { field_id: "subgroup", label: "Sub Group", group: "Classification" },
    { field_id: "productType", label: "Product Type", group: "Classification" },
    { field_id: "cableType", label: "Cable Type", group: "Classification" },
    { field_id: "productCategory", label: "Category", group: "Classification" },
    { field_id: "subCategory", label: "Sub Category", group: "Classification" },
    { field_id: "division", label: "Division", group: "Classification" },
    { field_id: "referenceOfStandard", label: "Reference of Standard", group: "Classification" },
    { field_id: "ISIMarked", label: "ISI Marked", group: "Classification" },
    { field_id: "voltage", label: "Voltage", group: "Classification" },
    { field_id: "construction", label: "Construction", group: "Classification" },
    { field_id: "code", label: "Code", group: "Classification" },
    { field_id: "noOfCores", label: "No. of Cores", group: "Classification" },
    { field_id: "color", label: "Color", group: "Classification" },
    { field_id: "nominalCrossSection", label: "Nominal Cross Section", group: "Classification" },
 
    // ---------- General ----------
    { field_id: "description", label: "Description", group: "General" },
    { field_id: "uom", label: "UOM", group: "General" },
    { field_id: "baseUnit", label: "Base Unit", group: "General" },
    { field_id: "weight", label: "Weight", group: "General" },
    { field_id: "referenceProductCode", label: "Reference Product Code", group: "General" },
    { field_id: "productClass", label: "Product Class", group: "General" },
    { field_id: "hsnCode", label: "HSN Code", group: "General" },
    { field_id: "qualityCategory", label: "Quality Category", group: "General" },
    { field_id: "productionClass", label: "Production Class", group: "General" },
    { field_id: "purchaseClass", label: "Purchase Class", group: "General" },
    { field_id: "conversionLengthM", label: "Conversion Length (m)", group: "General" },
    { field_id: "conversionWeightKg", label: "Conversion Weight (kg)", group: "General" },
 
    // ---------- Sales ----------
    { field_id: "itemCategory", label: "Item Category", group: "Sales" },
    { field_id: "sales_status", label: "Sales Status", group: "Sales" },
    { field_id: "salesOrganization", label: "Sales Organization", group: "Sales" },
    { field_id: "customerSegment", label: "Customer Segment", group: "Sales" },
    { field_id: "distributionChannel", label: "Distribution Channel", group: "Sales" },
    { field_id: "shippingFrom", label: "Shipping From", group: "Sales" },
    { field_id: "pricePerKm", label: "Price per Km", group: "Sales" },
    { field_id: "unitPrice", label: "Unit Price", group: "Sales" },
    { field_id: "format_no", label: "Format No.", group: "Sales" },
    { field_id: "test_type", label: "Test Type", group: "Sales" },
 
    // ---------- Purchase ----------
    { field_id: "purchaseOrganization", label: "Purchase Organization", group: "Purchase" },
    { field_id: "purchasePlanner", label: "Purchase Planner", group: "Purchase" },
    { field_id: "procurementType", label: "Procurement Type", group: "Purchase" },
    { field_id: "procurementLeadTime", label: "Procurement Lead Time", group: "Purchase" },
    { field_id: "moq", label: "MOQ", group: "Purchase" },
    { field_id: "countryOfOrigin", label: "Country of Origin", group: "Purchase" },
    { field_id: "purchase_status", label: "Purchase Status", group: "Purchase" },
    { field_id: "specialProcurement", label: "Special Procurement", group: "Purchase" },
 
    // ---------- MRP / Production ----------
    { field_id: "lotSize", label: "Lot Size", group: "MRP" },
    { field_id: "reOrderPoint", label: "Re-order Point", group: "MRP" },
    { field_id: "productionLeadTime", label: "Production Lead Time", group: "MRP" },
    { field_id: "MRP_status", label: "MRP Status", group: "MRP" },
    { field_id: "mrpPlanner", label: "MRP Planner", group: "MRP" },
    { field_id: "mrpClass", label: "MRP Class", group: "MRP" },
    { field_id: "mpq", label: "MPQ", group: "MRP" },
    { field_id: "characteristics", label: "Characteristics", group: "MRP" },
 
    // ---------- Quality / Logistics / Scheduling ----------
    { field_id: "relevantForQuality", label: "Relevant for Quality", group: "Quality & Logistics" },
    { field_id: "quality_status", label: "Quality Status", group: "Quality & Logistics" },
    { field_id: "storageType", label: "Storage Type", group: "Quality & Logistics" },
    { field_id: "logistics_status", label: "Logistics Status", group: "Quality & Logistics" },
    { field_id: "schedulePlanner", label: "Schedule Planner", group: "Quality & Logistics" },
    { field_id: "statusScheduling", label: "Scheduling Status", group: "Quality & Logistics" },
 
    // ---------- Accounting ----------
    { field_id: "productCost", label: "Product Cost", group: "Accounting" },
    { field_id: "currency", label: "Currency", group: "Accounting" },
    { field_id: "movingAveragePrice", label: "Moving Average Price", group: "Accounting" },
    { field_id: "accounting_status", label: "Accounting Status", group: "Accounting" },
 
    // ---------- Technical ----------
    { field_id: "material", label: "Material", group: "Technical" },
    { field_id: "nominalCrossSectionalArea", label: "Nominal Cross-Sectional Area", group: "Technical" },
    { field_id: "formOfConductor", label: "Form of Conductor", group: "Technical" },
    { field_id: "minNumberOfStrands", label: "Min. Number of Strands", group: "Technical" },
    { field_id: "sizeBeforeBunching", label: "Size Before Bunching", group: "Technical" },
    { field_id: "maxDcResistanceAt20C", label: "Max DC Resistance at 20°C", group: "Technical" },
    { field_id: "thickness", label: "Thickness", group: "Technical" },
    { field_id: "colourSchemeCores", label: "Colour Scheme (Cores)", group: "Technical" },
    { field_id: "colourInnerSheath", label: "Colour (Inner Sheath)", group: "Technical" },
    { field_id: "calculatedDiameter", label: "Calculated Diameter", group: "Technical" },
    { field_id: "whetherExtruded", label: "Whether Extruded", group: "Technical" },
 
    // ---------- Parameter blocks (10 / 10 columns each) ----------
    { field_id: "pg_parameters", label: "PG Parameters 1–10", group: "Parameters" },
    { field_id: "ccc_parameters", label: "CCC Parameters 1–10", group: "Parameters" }
  ],

  // Bill of Materials (tile id MD_BOM). field_id = bom table column / form key.
  MD_BOM: [
    // ---------- Header ----------
    { field_id: "product_code", label: "Product Code", group: "BOM Header" },
    // covers process_id and process_name
    { field_id: "process_id", label: "Process", group: "BOM Header" },
    { field_id: "product_description", label: "Product Description", group: "BOM Header" },
    { field_id: "base_unit", label: "Base Unit", group: "BOM Header" },
    { field_id: "UOM", label: "UOM", group: "BOM Header" },
    { field_id: "location", label: "Location", group: "BOM Header" },
    { field_id: "bom_usage", label: "BOM Usage", group: "BOM Header" },
    { field_id: "alternative_bom", label: "Alternative BOM", group: "BOM Header" },

    // ---------- Components table (one entry per column) ----------
    { field_id: "item", label: "Item", group: "Components" },
    { field_id: "product_type", label: "Product Type", group: "Components" },
    { field_id: "component_product", label: "Component Product Code", group: "Components" },
    { field_id: "component_description", label: "Component Description", group: "Components" },
    { field_id: "quantity", label: "Quantity", group: "Components" },
    { field_id: "uom_component", label: "Component UOM", group: "Components" },
    { field_id: "assembly", label: "Assembly", group: "Components" },
    { field_id: "valid_from", label: "Valid From", group: "Components" },
    { field_id: "valid_to", label: "Valid To", group: "Components" },

    // ---------- Documents tab ----------
    { field_id: "document_path", label: "Documents", group: "Documents" }
  ],

  // Work Center (tile id MD_WORKCENTER). field_id = workcenter column / form key,
  // except the grouped ids noted below.
  MD_WORKCENTER: [
    // ---------- Basic Data ----------
    { field_id: "workcenter_name", label: "Workcenter Name", group: "Basic Data" },
    { field_id: "workcenter_description", label: "Workcenter Description", group: "Basic Data" },
    { field_id: "workcenter_category", label: "Workcenter Category", group: "Basic Data" },
    { field_id: "person_responsible", label: "Person Responsible", group: "Basic Data" },
    { field_id: "location", label: "Location", group: "Basic Data" },

    // ---------- Capacity ----------
    { field_id: "capacity_category", label: "Capacity Category", group: "Capacity" },
    { field_id: "capacity_responsible", label: "Capacity Responsible", group: "Capacity" },
    { field_id: "factory_calendar", label: "Factory Calendar", group: "Capacity" },
    { field_id: "capacity_base_unit", label: "Capacity Base Unit", group: "Capacity" },
    { field_id: "no_of_capacity", label: "No. of Capacity", group: "Capacity" },
    { field_id: "capacity_by_length", label: "Capacity By Length", group: "Capacity" },
    { field_id: "available_capacity", label: "Available Capacity", group: "Capacity" },
    { field_id: "no_of_machines_breakdown", label: "No. of Machines Breakdown", group: "Capacity" },
    { field_id: "relevant_for_scheduling", label: "Relevant for Scheduling", group: "Capacity" },
    // the Configure Machines table (also covers workcenter-level capacity_utilization)
    { field_id: "machines", label: "Machines (Configure Machines table)", group: "Capacity" },

    // ---------- Classification ----------
    { field_id: "classifications", label: "Classifications", group: "Classification" },

    // ---------- Costing ----------
    { field_id: "start_date", label: "Start Date", group: "Costing" },
    { field_id: "end_date", label: "End Date", group: "Costing" },
    { field_id: "controlling_area", label: "Controlling Area", group: "Costing" },
    { field_id: "cost_center", label: "Cost Center", group: "Costing" },
    // covers setup / machine / labour / overhead and their UOMs
    { field_id: "activities", label: "Activity Types", group: "Costing" }
  ],

};

// The three Quality Inspection screens (FG / RM / Store Check) are all the
// same Quality.js engine, so they share one field list. Keys = tile ids in
// TILE_REGISTRY (these are the module_ids Create Role stores).
FIELD_REGISTRY.QM_INSPECTION_FG = FIELD_REGISTRY.QUALITY_INSPECTION;
FIELD_REGISTRY.QM_INSPECTION = FIELD_REGISTRY.QUALITY_INSPECTION;
FIELD_REGISTRY.QM_STORE_CHECK = FIELD_REGISTRY.QUALITY_INSPECTION;

export const getFieldsForModule = (moduleId) => FIELD_REGISTRY[moduleId] || [];